"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Nav = exports.ListItem = exports.List = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../../mediaQueries"));

var _hex2rgba = _interopRequireDefault(require("../../../utils/hex2rgba"));

var _templateObject;

var Wrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Wrapper",
  componentId: "sc-9ibd3f-0"
})(["", " background-color:", ";"], _mediaQueries["default"].smDown(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    display: none;\n  "]))), function (p) {
  return p.theme.tokens.colorBrand1;
});

exports.Wrapper = Wrapper;

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Container",
  componentId: "sc-9ibd3f-1"
})(["width:100%;max-width:", ";padding:0 ", ";margin:0 auto;"], function (p) {
  return p.theme.tokens.containerWidth;
}, function (p) {
  return p.theme.tokens.spacing05;
});

exports.Container = Container;

var Nav = /*#__PURE__*/_styledComponents["default"].nav.withConfig({
  displayName: "indexstyles__Nav",
  componentId: "sc-9ibd3f-2"
})([""]);

exports.Nav = Nav;

var List = /*#__PURE__*/_styledComponents["default"].ul.withConfig({
  displayName: "indexstyles__List",
  componentId: "sc-9ibd3f-3"
})(["display:flex;margin:0;padding:0;list-style-type:none;"]);

exports.List = List;

var ListItem = /*#__PURE__*/_styledComponents["default"].li.withConfig({
  displayName: "indexstyles__ListItem",
  componentId: "sc-9ibd3f-4"
})(["a{padding:", ";color:", ";font-weight:", ";text-decoration:none;&:active,&.active{color:", ";background:", ";}}&:last-child{padding-right:0;}a{display:inline-block;}"], function (p) {
  return "".concat(p.theme.tokens.spacing05, " ").concat(p.theme.tokens.spacing06);
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.fontWeightSemiBold;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return (0, _hex2rgba["default"])(p.theme.tokens.colorBackground, 0.5);
});

exports.ListItem = ListItem;